module.exports = __webpack_public_path__ + "static/media/market_research_diversity.3a9bfcee.png";